import { COLORS } from "../../../../styles/variables"

export const TypTitle = {
    fontSize: "15px",
    flex: 1, 
    minWidth: 0,
}

export const TypCity = {
    fontWeight: 300,
    color: COLORS.SMOKEY_GREY,
    mb: 1,
}

export const TypDescription = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    fontSize: '15px',
}

export const CounterLabel = {
    '@media (max-width: 374px)': {
        display: 'none',
    },
}

export const CounterIcon = {
    display: 'none',
    '@media (max-width: 374px)': {
        display: 'inline-flex',
    },
}
